export default "__VITE_ASSET__C7KMC5AZ__"